import { Translator } from '@itarget/shared'

export const useNoDataTranslation = () => ({
  empty: Translator({ transRef: 'translation.Sem registro' }).props.children,
})
